module.exports = __webpack_public_path__ + "img/speaker-LeonorRothes-imgs.3002c662.png";